export const getCronTriggerPath = (
  cronName:
    | 'payment-state-sync'
    | 'upcoming-payments'
    | 'scheduled-invoices'
    | 'scheduled-drops'
    | 'membership-fee-reminder'
    | 'expired-events',
  isV2: boolean,
): string => {
  // Membership fee reminder + expired-events are v1-only (no v2 job yet).
  if (
    cronName === 'membership-fee-reminder' ||
    cronName === 'expired-events'
  ) {
    return `/cron/${cronName}`;
  }
  return isV2 ? `/v2/cron/${cronName}` : `/cron/${cronName}`;
};
